import styled from './header.module.css';

function Header(props) {
    return (
        <div className={styled.header}>
            <a>Portal do cliente</a>
            <div className={styled.line}></div>
            <a>{props.page}</a>
        </div>
    )
}

export default Header;